import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

const LocalStorageUtil = () => {
  return <></>;
};
LocalStorageUtil.ldata = "";
LocalStorageUtil.ldataKey = "";
LocalStorageUtil.baseURL = "";
LocalStorageUtil.googleMapKey = "";
LocalStorageUtil.googleTagId = "";

LocalStorageUtil.setBaseURL = (url: any) => {
  LocalStorageUtil.baseURL = url;
};
LocalStorageUtil.getBaseURL = () => {
  return LocalStorageUtil.baseURL;
};
LocalStorageUtil.setGKey = (key: any) => {
  LocalStorageUtil.googleMapKey = key;
};
LocalStorageUtil.getGKey = () => {
  return LocalStorageUtil.googleMapKey;
};
LocalStorageUtil.setTagId = (key: any) => {
  LocalStorageUtil.googleTagId = key;
};
LocalStorageUtil.getTagId = () => {
  return LocalStorageUtil.googleTagId;
};
LocalStorageUtil.register = (key: any) => {
  LocalStorageUtil.ldataKey = key;
  try {
    if (sessionStorage.getItem(key)) {
      LocalStorageUtil.ldata = String(sessionStorage.getItem(key));
    }
  } catch (e: any) {
    LocalStorageUtil.ldata = "";
    sessionStorage.setItem(key, "");
  }
  sessionStorage.setItem("lastLoginKey", key);
  localStorage.setItem("lastLoginKey", key);
  LocalStorageUtil.setItem("baseUrl", LocalStorageUtil.baseURL);
  LocalStorageUtil.setItem("googleMapKey", LocalStorageUtil.googleMapKey);
};
LocalStorageUtil.setItem = (key: any, value: any) => {
  const selectedUser =
    LocalStorageUtil.ldataKey ||
    sessionStorage.getItem("lastLoginKey") ||
    "finpark";

  // Store in sessionStorage
  try {
    let sessionData =
      JSON.parse(String(sessionStorage.getItem(selectedUser))) || {};
    sessionData[key] = value;
    sessionStorage.setItem(selectedUser, JSON.stringify(sessionData));
  } catch (e: any) {
    console.error("Error setting session item:", e);
  }

  // Store all data in localStorage
  try {
    let localData =
      JSON.parse(String(localStorage.getItem(selectedUser))) || {};
    localData[key] = value;
    localStorage.setItem(selectedUser, JSON.stringify(localData));
  } catch (e: any) {
    console.error("Error setting local item:", e);
  }
};

LocalStorageUtil.getItem = (key: any) => {
  const selectedUser =
    LocalStorageUtil.ldataKey ||
    sessionStorage.getItem("lastLoginKey") ||
    localStorage.getItem("lastLoginKey") ||
    "finpark";

  // Try sessionStorage first
  try {
    const sessionData =
      JSON.parse(String(sessionStorage.getItem(selectedUser))) || {};
    if (sessionData[key]) return sessionData[key];
  } catch (e: any) {}

  // If sessionStorage not available, check localStorage
  try {
    const localData =
      JSON.parse(String(localStorage.getItem(selectedUser))) || {};
    return localData[key] || '""';
  } catch (e: any) {}

  return '""';
};

LocalStorageUtil.removeItem = (key: any) => {
  const selectedUser =
    LocalStorageUtil.ldataKey ||
    sessionStorage.getItem("lastLoginKey") ||
    "finpark";

  // Remove from sessionStorage
  try {
    let sessionData =
      JSON.parse(String(sessionStorage.getItem(selectedUser))) || {};
    delete sessionData[key];
    sessionStorage.setItem(selectedUser, JSON.stringify(sessionData));
  } catch (e: any) {}

  // Remove from localStorage
  try {
    let localData =
      JSON.parse(String(localStorage.getItem(selectedUser))) || {};
    delete localData[key];
    localStorage.setItem(selectedUser, JSON.stringify(localData));
  } catch (e: any) {}
};

// Copy session to localStorage (called on tab close/refresh)
LocalStorageUtil.copySessionToLocal = () => {
  const selectedUser =
    LocalStorageUtil.ldataKey ||
    sessionStorage.getItem("lastLoginKey") ||
    "finpark";
  const sessionData = sessionStorage.getItem(selectedUser);
  if (sessionData) {
    localStorage.setItem(`${selectedUser}_backup`, sessionData);
  }
};

// Restore session from localStorage (called on new tab open)
LocalStorageUtil.restoreSessionFromLocal = () => {
  const selectedUser = localStorage.getItem("lastLoginKey") || "finpark";
  const backupData = localStorage.getItem(`${selectedUser}_backup`);

  if (backupData && !sessionStorage.getItem(selectedUser)) {
    sessionStorage.setItem("lastLoginKey", selectedUser);
    sessionStorage.setItem(selectedUser, backupData);
    LocalStorageUtil.ldataKey = selectedUser;

    // Remove backup after restoring
    localStorage.removeItem(`${selectedUser}_backup`);
  }
};

// Set current path as last viewed page for new tab
LocalStorageUtil.setCurrentPathAsLastViewed = (path: any) => {
  const selectedUser =
    LocalStorageUtil.ldataKey ||
    sessionStorage.getItem("lastLoginKey") ||
    "finpark";
  if (path && path !== "/") {
    // Save to localStorage
    try {
      let localData =
        JSON.parse(String(localStorage.getItem(selectedUser))) || {};
      localData["finparkLastViewedPage"] = path;
      localStorage.setItem(selectedUser, JSON.stringify(localData));
    } catch (e: any) {}

    // Save to sessionStorage
    try {
      let sessionData =
        JSON.parse(String(sessionStorage.getItem(selectedUser))) || {};
      sessionData["finparkLastViewedPage"] = path;
      sessionStorage.setItem(selectedUser, JSON.stringify(sessionData));
    } catch (e: any) {}
  }
};

LocalStorageUtil.clearAllSessions = () => {
  sessionStorage.clear();
  const selectedUser = LocalStorageUtil.ldataKey || "finpark";
  localStorage.removeItem(selectedUser);
  localStorage.removeItem(`${selectedUser}_backup`);
  LocalStorageUtil.ldata = "";
  LocalStorageUtil.ldataKey = "";
};

export { LocalStorageUtil };
